export const URL_MAPPING = {
  default: {
    parent_host: 'http://172.16.0.217',
    current_host: 'http://172.16.0.217:2141',
    vendx2_host: 'http://192.168.1.14:5014',
  },

  'testing187.vend-x.com': {
    parent_host: 'https://testing187.vend-x.com',
    current_host: 'https://testing.vendx.ai',
    vendx2_host: 'https://testing187-vendx2.vend-x.com',
    api_host: 'https://transcriber.vendx.ai',
  },
  'testing181.vend-x.com': {
    parent_host: 'https://testing181.vend-x.com',
    current_host: 'https://testing181.vend-x.com',
    vendx2_host: 'https://testing172-vendx2.vend-x.com',
    api_host: 'https://transcriber.vendx.ai',
  },
  'testing185.vend-x.com': {
    parent_host: 'https://testing185.vend-x.com',
    current_host: 'https://testing.vendx.ai',
    vendx2_host: 'https://testing172-vendx2.vend-x.com',
    api_host: 'https://transcriber.vendx.ai',
  },
  'testing.vendx.ai': {
    parent_host: 'https://testing187.vend-x.com',
    current_host: 'https://testing.vendx.ai',
    vendx2_host: 'https://testing187-vendx2.vend-x.com',
    api_host: 'https://transcriber.vendx.ai',
  },

  'vend-x.com': {
    parent_host: 'https://vend-x.com',
    current_host: 'https://static.vendx.ai',
    current_iframe_host: 'vendx',
    vendx2_host: 'https://api.vend-x.com',
    api_host: 'https://transcriber.vendx.ai',
  },

  'ultratechcement.vend-x.com': {
    parent_host: 'https://ultratechcement.vend-x.com',
    current_host: 'https://static.vendx.ai',
    vendx2_host: 'https://utclapi.vend-x.com',
    current_iframe_host: 'utcl',
    api_host: 'https://transcriber.vendx.ai',
  },

  'ej-buy.com': {
    parent_host: 'https://ej-buy.com',
    current_host: 'https://static.vendx.ai',
    vendx2_host: 'https://ejbuyapi.ej-buy.com',
    current_iframe_host: 'ejbuy',
    api_host: 'https://transcriber.vendx.ai',
  },
  'auction.ej-buy.com': {
    parent_host: 'https://ej-buy.com',
    current_host: 'https://static.vendx.ai',
    vendx2_host: 'https://ejbuyapi.ej-buy.com',
    current_iframe_host: 'ejbuy',
    api_host: 'https://transcriber.vendx.ai',
  },
  'auction.vend-x.com': {
    parent_host: 'https://vend-x.com',
    current_host: 'https://static.vendx.ai',
    vendx2_host: 'https://api.vend-x.com',
    current_iframe_host: 'vendx',
    api_host: 'https://transcriber.vendx.ai',
  },

  'ultratechauction.vend-x.com': {
    parent_host: 'https://ultratechcement.vend-x.com',
    current_host: 'https://static.vendx.ai',
    vendx2_host: 'https://utclapi.vend-x.com',
    current_iframe_host: 'utcl',
    api_host: 'https://transcriber.vendx.ai',
  },
  '192.168.1.14': {
    parent_host: 'http://192.168.1.14',
    current_host: 'http://192.168.1.14',
  },

  '172.16.0.217:2141': {
    parent_host: 'http://192.168.1.14',
    current_host: 'http://172.16.0.217:2141',
    vendx2_host: 'http://192.168.1.14:5014',
  },
  '172.16.0.217:8141': {
    parent_host: 'http://192.168.1.14',
    current_host: 'http://172.16.0.217:8141',
    vendx2_host: 'http://192.168.1.14:5014',
  },
  '172.16.0.217:8142': {
    parent_host: 'http://192.168.1.14',
    current_host: 'http://172.16.0.217:8142',
    vendx2_host: 'https://testing187-vendx2.vend-x.com',
    // api_host : " https://transcriber.vendx.ai",
    // api_host : "http://43.204.136.81:8000",
    api_host: 'http://43.204.136.81:8505',
    // token_host: "http://43.204.136.81:8502",
  },
  'localhost:3169': {
    parent_host: 'http://192.168.1.14',
    current_host: 'http://localhost:3166',
    vendx2_host: 'http://192.168.1.161:3164',
    // api_host : " https://transcriber.vendx.ai",
    // api_host : "http://43.204.136.81:8000",
    api_host: 'http://43.204.136.81:8505',
    // token_host: "http://43.204.136.81:8502",
    // parent_host: "http://192.168.1.14",
    // current_host : "http://172.16.0.217:8142",
    // "vendx2_host" : "http://192.168.1.14:5014",
    // // api_host : " https://transcriber.vendx.ai",
    // // api_host : "http://43.204.136.81:8000",
    // api_host : "http://43.204.136.81:8505",
    // token_host : "http://43.204.136.81:8502"
  },

  '172.16.0.217:3153': {
    parent_host: 'http://172.16.0.217',
    current_host: 'http://172.16.0.217:3153',
    vendx2_host: 'https://testing187-vendx2.vend-x.com',
    // api_host : " https://transcriber.vendx.ai",
    // api_host : "http://43.204.136.81:8000",
    api_host: 'https://testing-transcriber-api.vendx.ai',
    // token_host: "http://43.204.136.81:8502",
  },
  'testing-transcribe.vendx.ai': {
    parent_host: 'https://testing187.vend-x.com',
    current_host: 'testing-transcribe.vendx.ai',
    vendx2_host: 'https://testing187-vendx2.vend-x.com',
    api_host: 'https://testing-transcriber-api.vendx.ai',
    // token_host: "http://43.204.136.81:8502",
  },
  'transcriber.vendx.ai': {
    parent_host: 'https://transcriber.vendx.ai',
    current_host: 'transcriber.vendx.ai',
    vendx2_host: 'https://api.vend-x.com',
    api_host: 'https://transcriber-api.vendx.ai',
  },
  'transcribe.vendx.ai': {
    parent_host: 'https://transcribe.vendx.ai',
    current_host: 'transcribe.vendx.ai',
    vendx2_host: 'https://api.vend-x.com',
    api_host: 'https://transcriber-api.vendx.ai',
  }
};